function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M46.7,59.4H9.5L19,31.8v-13h17.1v13L46.7,59.4z M13.7,56.4h28.6l-9.2-24.1V21.8H22v10.5L13.7,56.4z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 14.4,
  y: 47.8,
  width: 26.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 20.5,
  y: 30.6,
  width: 14.1,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M21.1,14.5c-3.9,0-7-3.1-7-7s3.1-7,7-7c3.9,0,7,3.1,7,7S24.9,14.5,21.1,14.5z M21.1,3.6c-2.2,0-4,1.8-4,4s1.8,4,4,4 s4-1.8,4-4S23.3,3.6,21.1,3.6z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
  cx: 31.8,
  cy: 13.2,
  r: 3.2
})))));

var SvgExperimentStatic = function SvgExperimentStatic(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/experiment-static.9334fd09.svg";
export { SvgExperimentStatic as ReactComponent };